module.exports = __webpack_public_path__ + "static/img/guanbi1_btn.6ef42542.png";